import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from 'src/state/app.state';
import { selectPageEnabledStatus, selectLoadingSpinnerStatus, selectNoConfigDataStatus } from 'src/state/app-meta/app-meta.selectors';
import { SubscriptionService } from './services/subscription.service';
import { Observable } from 'rxjs';
import { ConfigApiService } from './services/config-api.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  public disablePage$: Observable<boolean> = this.store.select(selectPageEnabledStatus);
  public stopSpinner$: Observable<boolean> = this.store.select(selectLoadingSpinnerStatus);
  public noConfigData$: Observable<boolean> = this.store.select(selectNoConfigDataStatus);

  public isProd: boolean = environment.production;

  constructor(
    private store: Store<AppState>,
    private subService: SubscriptionService,
    private configApiService: ConfigApiService
  ) { }
}